import { z } from "zod";

export const schema = z.object({
	param: z.object({
		value: z.string(),
		label: z.string(),
	}),
	paramValue: z.string(),
	active: z.boolean(),
});
